export const playerV2Filter = ({ dashboardPlayerVersion }) => dashboardPlayerVersion >= 2;
